module.exports = __webpack_public_path__ + "static/media/la-corporate-catering-2.4bf0931c.jpg";